import React from 'react';
import classes from './ContactAddress.css';


const contactAddress = () => (
    <div className={classes.contactAddress}>
                <h2> Address </h2>
                <p><span className={classes.appDecorativeLabel} >House No:</span>367</p>
                <p><span  className={classes.appDecorativeLabel}>Street:</span> 21</p>
                <p><span className={classes.appDecorativeLabel}>Locality:</span> Shakit Nagar</p>
                <p><span className={classes.appDecorativeLabel}>City:</span> Derabassi</p>
                <p><span className={classes.appDecorativeLabel} >State:</span> Punjab</p>
                <p><span className={classes.appDecorativeLabel}>Dist.:</span> S.A.S Nagar Mohali</p>
                <div className={classes.contactInfo} >
                <p><i className="fa fa-phone"></i> +917347449073</p>
                <p><i className="fa fa-envelope"></i> mayanksagar226@gmail.com</p>
                </div>
        </div>
);

export default contactAddress;


// WEBPACK FOOTER //
// ./src/components/Sections/ContactAddress/ContactAddress.js